export default {"src":"/_next/static/media/chickeniconblack.6af740ef.svg","height":64,"width":64};